<template>
    <ul v-if="documents.length > 0" class="mt-2 max-h-64 overflow-y-auto overflow-x-hidden">
        <li v-for="(document, index) in documents" :key="`document-${index}`" class="py-1">
            <a
                :href="document.link"
                target="_blank"
                class="block w-48 truncate whitespace-nowrap text-sm"
                @click="sendDownloadEvent(document)">
                <DocumentTextIcon class="mr-1 inline-block h-5 w-5 align-middle" />
                {{ document.name }}
            </a>
        </li>
    </ul>
    <p v-else class="mt-2">{{ $t('portfolio.orders.no_documents_to_show') }}</p>
</template>

<script setup lang="ts">
import { DocumentTextIcon } from '@heroicons/vue/outline'
import useEventStore from '../../utilities/useEvent'
const props = defineProps<{
    type: string
    documents: {
        name: string
        link: string
    }[]
}>()

const eventStore = useEventStore()

const sendDownloadEvent = (document: { name: string; link: string }) => {
    eventStore.trackEvent({
        event: 'open_document',
        data: {
            document_name: document.name,
            document_link: document.link,
            document_type: props.type,
        },
    })
}
</script>

<style scoped></style>
